import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { defaultLanguage, isSupportedLanguage } from '@/data/languages';

export default function LanguageRedirect() {
  const navigate = useNavigate();

  useEffect(() => {
    const nav = (typeof navigator !== 'undefined' ? navigator.language : '') || 'en';
    const prefix = nav.slice(0, 2).toLowerCase();
    const target = isSupportedLanguage(prefix) ? prefix : defaultLanguage;
    navigate(`/${target}`, { replace: true });
  }, [navigate]);

  return null;
}